import {
  USER_LOGIN_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_FETCH_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_LOGOUT_REQUEST,
  USER_LOGOUT_SUCCESS,
  AuthState,
  AuthenticationAction,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAILURE,
  CHECK_INVITATION_SUCCESS,
  CHECK_INVITATION_FAILURE,
  RESET_STATE
} from "./types";

const cachedUserOrNull = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user") as string)
  : null;

const initState: AuthState = {
  isAuthenticating: false,
  isVerifiedInvitation: false,
  user: cachedUserOrNull,
  error: null,
  isSuccessSignedup: false
};

const auth = (
  state: AuthState = initState,
  action: AuthenticationAction | undefined
) => {
  if (action === undefined) {
    return initState;
  }
  const { type, payload } = action;
  switch (type) {
    case USER_LOGIN_REQUEST:
      return {
        user: null,
        isAuthenticating: true,
        error: null
      };
    case CHECK_INVITATION_SUCCESS:
      return {
        user: null,
        isAuthenticating: false,
        error: null,
        isSuccessSignedup: false,
        isVerifiedInvitation: true
      };
    case CHECK_INVITATION_FAILURE:
      return {
        user: null,
        isAuthenticating: false,
        error: payload,
        isSuccessSignedup: false,
        isVerifiedInvitation: true
      };
    case USER_REGISTER_SUCCESS:
      return {
        user: null,
        isAuthenticating: false,
        error: null,
        isSuccessSignedup: true,
        isVerifiedInvitation: true
      };
    case USER_REGISTER_FAILURE:
      return {
        user: null,
        isAuthenticating: false,
        error: payload,
        isSuccessSignedup: false
      };
    case USER_UPDATE_SUCCESS:
    case USER_FETCH_SUCCESS:
      return {
        user: payload,
        isAuthenticating: false,
        error: null
      };
    case USER_LOGIN_FAILURE:
      return {
        user: null,
        isAuthenticating: false,
        error: payload
      };
    case USER_LOGOUT_REQUEST:
      return state;
    case USER_LOGOUT_SUCCESS:
      return {
        user: null,
        isAuthenticating: false,
        error: null
      };
    case RESET_STATE:
      return {
        user: null,
        isAuthenticating: false,
        error: null
      };
    default:
      return state;
  }
};

export default auth;
